import React from "react";
import Slot from "./Slot/Slot";
import "./SlotCheckbox.css";

class SlotCheckbox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
    };

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
  }

  handleCheckboxClick() {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  }

  render() {
    return (
      <div className="slot-radio-input-grp">
        <label
          htmlFor={this.props.name + "_input"}
          className="slot-radio-input-label"
          onClick={this.handleCheckboxClick}
        >
          <div className="slot-radio-header">
            <div className="slot-radio-input-img">
              <Slot slotIsActive={this.props.isSelectedTrue} />
              <input
                type="checkbox"
                name={this.props.name}
                id={this.props.name + "_input"}
                defaultChecked={this.state.isChecked}
                onChange={this.props.handleCheckboxChange}
              />
            </div>
            <div className="slot-radio-headline">
              {this.props.inputHeadline}
            </div>
          </div>

          <div className="slot-radio-text body-text">
            {this.props.inputText}
          </div>
        </label>
      </div>
    );
  }
}

// class SlotCheckbox extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       isChecked: false,
//     };

//     this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
//   }

//   handleCheckboxClick() {
//     this.setState({
//       isChecked: !this.state.isChecked,
//     });
//   }

//   render() {
//     return (
//       <div className="slot-radio-input-grp">
//         <label
//           htmlFor={this.props.name + "_input"}
//           className="slot-radio-input-label"
//         >
//           <div className="slot-radio-header">
//             <div
//               className="slot-radio-input-img"
//               onClick={this.handleCheckboxClick}
//             >
//               <Slot slotIsActive={this.props.isSelectedTrue} />
//               <input
//                 type="checkbox"
//                 name={this.props.name}
//                 id={this.props.name + "_input"}
//                 defaultChecked={this.state.isChecked}
//                 onChange={this.props.handleCheckboxChange}
//               />
//             </div>
//             <div className="slot-radio-headline">
//               {this.props.inputHeadline}
//             </div>
//           </div>

//           <div className="slot-radio-text body-text">
//             {this.props.inputText}
//           </div>
//         </label>
//       </div>
//     );
//   }
// }

export default SlotCheckbox;
